import React from "react";
import { getTranslationField } from "utils";


const SingleBenefit = ({ benefit, language }) => (
  <div className="single-benefit-section">
    <div className={`level-benefit-icon ${benefit.highlight ? 'active' : ''}`} >
      <div />
      <div />
    </div>
    <div>
      <div className="single-benefit-title subheading">{getTranslationField(benefit, "title", language)}</div>
      <div className="single-benefit-content body-2">{getTranslationField(benefit, "content", language)}</div>
    </div>
  </div>
);

const LevelBenefitSection = ({
  benefits,
  language,
}) => (
  <div className="level-benefit-section">
    {benefits && benefits?.length > 0 &&
      benefits.map(benefit => (
        <SingleBenefit
          key={benefit.id}
          benefit={benefit}
          language={language}
        />
      ))
    }
  </div>
);

export default LevelBenefitSection;
